/** PURE_IMPORTS_START ._IntervalObservable PURE_IMPORTS_END */
import { IntervalObservable } from './IntervalObservable';
export var interval = IntervalObservable.create;
//# sourceMappingURL=interval.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/interval.js
// module id = 775
// module chunks = 0